import colors from '__designkit__/common/colors';
import Fonts from '__designkit__/common/fonts';
import Icon from '__designkit__/icon/Icon';
import V2Icon from '__pc__/components/common/v2Design/icon';
import V2Text from '__pc__/components/common/v2Design/text';
import { V2BackgroundColors } from '__pc__/constant/v2Design/Colors/V2BackgroundColors';
import { V2IconColors } from '__pc__/constant/v2Design/Colors/V2IconColors';
import { SpaceValue } from '__pc__/constant/v2Design/SpaceType';
import { V2IconOption } from '__pc__/constant/v2Design/V2IconType';
import { V2TextOption } from '__pc__/constant/v2Design/V2TextType';
import { inject, observer } from 'mobx-react';
import Context from 'models/Context';
import { injectStore } from 'models/store';
import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import ScrollUtil from 'utils/ScrollUtil';
import MatchMessageStore from 'models/MatchMessageStore';
import { MatchingMessageProposalType } from 'interfaces/rqrs/IMatchingMessageListRs';
import MatchApplySuggestMessage from './MatchApplySuggestMessage';
import MatchApplyJobDescription from './MatchApplyJobDescription';

const Frame = styled.div`
position: relative;
  .divider {
    margin: 32px 0;
  }
`;

const MessageTab = styled.div`
  position: sticky;
  display: flex;
  flex-direction: column;
  z-index: 100;
  display: flex;
  align-items: center;
  width: 100%;
  top: calc(env(safe-area-inset-top) + 64px);
  transition: top .25s;
  background: ${colors.WHITE_100};
  .message-tab-container {
    display: flex;
    padding: ${SpaceValue.M}px ${SpaceValue.L}px;

    gap: ${SpaceValue.XL}px;
    width: 100%;
    justify-content: flex-start;
  }
  .a-link {
    position: relative;
    width: fit-content;
    padding-bottom: 4px;

    &[aria-current=true]:before {
      display: block;
      position: absolute;
      content: '';
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background: ${colors.JOBDA_BLACK};
    }
  }
`;
const CompanyBandFrame = styled.div`
    display: flex;
    width: 100%;
    padding:${SpaceValue.M}px ${SpaceValue.XL}px;
    align-items: center;
    justify-content: center;
    gap: ${SpaceValue.XS}px;
    background-color: ${V2BackgroundColors.accent_skyblue_subtle};
`;
const JobdaBandFrame = styled.div`
    display: flex;
    width: 100%;
    padding:${SpaceValue.M}px ${SpaceValue.XL}px;
    align-items: center;
    justify-content: center;
    gap: ${SpaceValue.XS}px;
    background-color: ${V2BackgroundColors.accent_green_subtle};
`;
export interface IMatchApplyStatusMessage {
  matchMessageStore?: MatchMessageStore;
}

interface IMessageTab {
  tabId: number;
  tabName: string;
  tab: string;
}

export const MessageTabRoute = {
  received: 'received',
  sent: 'sent',
};

const MatchApplyStatusMessageTab: FC<IMatchApplyStatusMessage> = ({ matchMessageStore = new MatchMessageStore() }) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [currentTab, setCurrentTab] = useState<number>(0);
  const messageTab: IMessageTab[] = [
    { tabId: 0, tabName: '제안 메시지', tab: 'received' },
    { tabId: 1, tabName: '직무 설명서', tab: 'sent' },
  ];

  const blendHandler = async () => {
    const scrollTop = await ScrollUtil.getScrollTop();
    setScrollPosition(scrollTop);
  };

  useEffect(() => {
    ScrollUtil.addEventListener(blendHandler);
    return () => {
      ScrollUtil.removeEventListener(blendHandler);
    };
  }, []);

  const handleTabClick = (tabId: number) => {
    let newTab = '';
    if (tabId === 0) {
      newTab = MessageTabRoute.received;
    } else if (tabId === 1) {
      newTab = MessageTabRoute.sent;
    }

    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has('tab')) {
      queryParams.set('tab', newTab);
    } else {
      queryParams.append('tab', newTab);
    }

    const updatedURL = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.replaceState({}, document.title, updatedURL);
    setCurrentTab(tabId);
  };

  return (
    <Frame>
      <MessageTab>
        <div className='message-tab-container'>
          {messageTab.map((tabItem: IMessageTab, idx) => (
            <button
              key={tabItem.tabId}
              onClick={() => handleTabClick(idx)}
              type='button'
            >
              <div
                className='a-link'
                aria-current={currentTab === idx ? 'true' : undefined}
              >
                <V2Text
                  fontStyle={currentTab === idx ? V2TextOption.fontStyle.body_2_sb : V2TextOption.fontStyle.body_2_m}
                  color={currentTab === idx ? V2TextOption.color.default : V2TextOption.color.disabled}
                >
                  {tabItem.tabName}
                </V2Text>
              </div>
            </button>
          ))}

        </div>
        {matchMessageStore.matchingMessage?.proposalType === MatchingMessageProposalType.DELIVERY_PROPOSAL
          ? (
            <CompanyBandFrame>
              <V2Icon name='circle-info' size={V2IconOption.size.S} fill={V2IconOption.fill.information} />
              <V2Text fontStyle={V2TextOption.fontStyle.body_2_sb} color={V2TextOption.color.information}>
                인사담당자가 직접 발송한 제안입니다.
              </V2Text>
            </CompanyBandFrame>
          )
          : (
            <JobdaBandFrame>
              <V2Icon name='circle-info' size={V2IconOption.size.S} fill={V2IconOption.fill.accent_green} />
              <V2Text fontStyle={V2TextOption.fontStyle.body_2_sb} color={V2TextOption.color.accent_green_default}>
                잡다매칭에서 발송한 제안입니다.
              </V2Text>
            </JobdaBandFrame>
          )}
      </MessageTab>

      {currentTab === 0
      && (
        <MatchApplySuggestMessage />
      )}
      {currentTab === 1 && <MatchApplyJobDescription />}
    </Frame>
  );
};

export default inject(injectStore.matchMessageStore)(observer(MatchApplyStatusMessageTab));
